import React from 'react';
import { MapPin } from 'lucide-react';
const CITIES = ['Phoenix', 'Mesa', 'Gilbert', 'Chandler', 'Scottsdale', 'Tempe', 'Glendale', 'Peoria', 'Surprise', 'Goodyear', 'Avondale'];
export function ServiceArea() {
  return <section id="service-area" className="py-24 bg-dark relative overflow-hidden" data-id="element-207">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#dc2626 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-208" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-209">
        <div className="max-w-4xl mx-auto bg-surface rounded-2xl border border-accent/20 p-8 md:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-12" data-id="element-210">
          <div className="flex-1 text-center md:text-left" data-id="element-211">
            <div className="inline-flex items-center gap-2 text-accent-light font-bold uppercase tracking-wider mb-4" data-id="element-212">
              <MapPin className="h-5 w-5" data-id="element-213" />
              East & West Valley Covered
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-214">
              Serving the <span className="text-accent" data-id="element-215">Valley of the Sun</span>
            </h2>
            <p className="text-slate-400 text-lg mb-8" data-id="element-216">
              We bring our premium pressure washing services directly to your
              doorstep across the greater Phoenix metropolitan area.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-217">
              {CITIES.map(city => <span key={city} className="px-4 py-2 rounded-full bg-dark border border-accent/30 text-slate-300 text-sm font-medium" data-id="element-218">
                  {city}
                </span>)}
            </div>
          </div>

          <div className="w-full md:w-1/3 flex justify-center" data-id="element-219">
            <div className="relative w-48 h-48 rounded-full bg-dark border-4 border-accent/20 flex items-center justify-center shadow-[0_0_50px_rgba(220,38,38,0.2)]" data-id="element-220">
              <MapPin className="h-20 w-20 text-accent-light absolute z-10 -mt-4" data-id="element-221" />
              <div className="absolute inset-0 rounded-full border border-accent animate-ping opacity-20" data-id="element-222" />
              <div className="absolute inset-4 rounded-full border border-accent animate-ping opacity-40" style={{
              animationDelay: '0.5s'
            }} data-id="element-223" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}